export enum EnumApiTonghao {
  Moments = '/moment/api/moments/mix/bytopic'
}
